export default "__VITE_ASSET__BD9Alog7__"